export function Footer() {
    return (
        <div className="main-footer">
            <div className="container-fluid pd-t-0-f ht-100p">
                Copyright © 2022 <a target="_blank" rel="noreferrer" href="https://itmedia.io/" className="text-primary">itmedia</a>.
            </div>
        </div>
    )
}